import { Formik } from "formik";
import React, { useEffect, useState } from "react";
import { AiFillEdit, AiFillLock, AiFillUnlock } from "react-icons/ai";
import { FaCloudUploadAlt, FaSave, FaShare } from "react-icons/fa";
import Submit from "../../../../components/Form/Submit";
import Grid from "../../../../components/Grid";
import { FlexContainer } from "../../../../components/StyledComponents";
import {
  schema,
  initialValues,
} from "../../../../constants/form/image/create-image";
import TextArea from "./components/TextArea";
import { RiCloseCircleFill } from "react-icons/ri";
import {
  ImageUploaderDescriptionWrapper,
  ImageUploaderTitle,
  ImageUploadWrapper,
  ImageImagePreview,
} from "./style";
import InputDescription from "./components/Field/index";
import { BiLink } from "react-icons/bi";
import { BsFillTrash2Fill } from "react-icons/bs";
import { FiUpload } from "react-icons/fi";
import { HiUserAdd } from "react-icons/hi";
import { toast } from "react-toastify";
import { showModal } from "../../../../store/actions/modal";
import { connect, useDispatch } from "react-redux";
import { ImageDto } from "../../../../types/image.dto";
import SideBar from "./components/SideBar";
import Loader from "../../../../components/Loader";
import { useNavigate, useParams } from "react-router-dom";
import { StateDto } from "../../../../types/states.dto";
import Button from "../../../../components/Button";
import PublishImageModal from "./components/PublishImageModal";
import AddUsersModal from "./components/AddUsersModal";
import { UsersDto } from "../../../../types/users.dto";
import ShareModal from "./components/ShareModal";
import PrivateModal from "./components/PrivateModal";
import ModalConfirmDelete from "../../../../components/ModalConfirmDelete";
import { CurrentDto } from "../../../../types/current.dto";
import { setFormData } from "../../../../helpers/formData";
import Input from "../../../../components/Form/Input";
import {
  deleteImage,
  newImage as newImageAction,
  resetDeleteImage,
  resetGetImage,
  resetNewImage,
  resetUpdateImage,
  updateImage,
} from "../../../../store/actions/image";
import {
  GET_IMAGE_SUCCESS,
  SET_GET_IMAGE,
} from "../../../../store/types/image";
import { getImage } from "../../../../store/actions/image";
import DropzoneField from "../../../../components/Form/Dropzone";
import {
  getAllCohorts,
  resetGetAllCohortsData,
} from "../../../../store/actions/cohort";
import { getAllUnits, resetGetAllUnits } from "../../../../store/actions/unit";
import { CohortDto } from "../../../../types/cohort.dto";
import { UnitDto } from "../../../../types/unit.dto";
const Component = ({
  image,
  imageGetStates,
  imageUpdateStates,
  users,
  imageDeleteStates,
  images,
  current,
  newImageDataStates,
  user,
  newImage,
  updateImageStates,
  getImageStates,
  deleteImageStates,
  cohorts,
  units,
}: {
  image: ImageDto;
  imageGetStates: StateDto;
  imageUpdateStates: StateDto;
  users: UsersDto[];
  imageDeleteStates: StateDto;
  images: ImageDto[];
  current: CurrentDto;
  newImageDataStates: StateDto;
  user: UsersDto;
  newImage: ImageDto;
  updateImageStates: StateDto;
  getImageStates: StateDto;
  deleteImageStates: StateDto;
  cohorts: CohortDto[];
  units: UnitDto[];
}) => {
  const [fetchOn, setFetchOn] = useState<boolean>(false);
  const [formSubmmited, setFormSubmmited] = useState(false);
  const [currentImage, setCurrentImage] = useState<{
    file: any;
    preview: any;
  }>();
  const [imageDataChanged, setImageDataChanged] = useState<{
    name: string;
    description: string;
  }>({ name: "", description: "" });
  const [imageApi, setImageApi] = useState<string>();
  const params = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const onSubmit = (values, actions) => {
    if (!image) {
      dispatch(
        newImageAction(
          setFormData(
            {
              name: values.name,
              description: values.description,
              ...(!!currentImage && { picture: currentImage?.file }),

              academy: current.id,
              type: "IMAGE",
              published: true,
              allCohorts: true,
              available: true,
            },
            ["picture"]
          )
        )
      );
    } else {
      dispatch(
        updateImage({
          _id: image._id,
          body: setFormData(
            {
              name: values.name,
              description: values.description,
              ...(!!currentImage && { picture: currentImage?.file }),

              published: true,
              allCohorts: values.allCohorts,
              available: values.available,
              __v: image.__v,
            },
            ["picture"]
          ),
        })
      );
    }
  };

  const onSelectImage = (files) => {
    if (files.length <= 0) {
      setCurrentImage(undefined);

      return;
    }

    // I've kept this example simple by using the first image instead of multiple
    setCurrentImage({
      file: files[0],
      preview: URL.createObjectURL(files[0]),
    });
  };

  const menu = [
    {
      imageRole: ["OWNER"],
      Icon: FiUpload,
      toolTipName: !!image?.published
        ? "Editar publicacion"
        : "Publicar Contenido",
      onClick: () => {
        dispatch(showModal("publish-image-modal"));
      },
      IconActive: AiFillEdit,
      activeFunction: () => !!image?.published,
      onClickActive: () => {
        dispatch(showModal("publish-image-modal"));
      },
    },
    {
      Icon: AiFillLock,
      imageRole: ["OWNER"],
      IconActive: AiFillUnlock,
      toolTipName: "Cambiar visibilidad",
      onAvailable: () => !!image && !!image?.published,
      activeFunction: () => !!image?.published,
      onClick: () => {
        dispatch(showModal("private-image"));
      },
      onClickActive: () => {
        dispatch(showModal("private-image"));
      },
    },
    {
      Icon: HiUserAdd,
      imageRole: ["OWNER", "COOWNER"],
      toolTipName: "Añadir Usuarios",
      onClick: () => {
        dispatch(showModal("add-user-image"));
      },
      onAvailable: () => !!image && !!image?.published,
    },
    {
      Icon: FaSave,
      onClick: () => {},
      toolTipName: "Guardar",
      imageRole: ["OWNER", "COOWNER"],
      onAvailable: () =>
        (!image &&
          imageDataChanged.name?.length > 5 &&
          imageDataChanged.description?.length > 0 &&
          !!currentImage) ||
        (!!image &&
          imageDataChanged.name?.length > 5 &&
          imageDataChanged.description?.length > 0 &&
          (imageDataChanged.description !== image.description ||
            imageDataChanged.name !== image.name)),
      activeFunction: () =>
        (!image &&
          imageDataChanged.name?.length > 5 &&
          imageDataChanged.description?.length > 0 &&
          !!currentImage) ||
        (!!image &&
          imageDataChanged.name?.length > 5 &&
          imageDataChanged.description?.length > 0 &&
          (imageDataChanged.description !== image.description ||
            imageDataChanged.name !== image.name)),
      onClickActive: () => {
        if (!image) {
          dispatch(
            newImageAction(
              setFormData(
                {
                  name: imageDataChanged.name,
                  description: imageDataChanged.description,
                  type: "IMAGE",
                  ...(!!currentImage && { picture: currentImage?.file }),
                  academy: current.id,
                },
                ["picture"]
              )
            )
          );
        } else {
          dispatch(
            updateImage({
              _id: image._id,
              body: setFormData(
                {
                  name: imageDataChanged.name,
                  description: imageDataChanged.description,
                  ...(!!currentImage && { picture: currentImage?.file }),

                  __v: image.__v,
                },
                ["picture"]
              ),
            })
          );
        }
      },
    },
    {
      Icon: BiLink,
      imageRole: ["OWNER", "COOWNER", "READER"],
      toolTipName: "Copiar Link",
      onAvailable: () => !!image && !!image.available && !!image.published,
      onClick: () => {
        navigator.clipboard.writeText(
          `https://academia.batan.coop/dashboard/images/${image._id}`
        );
        toast.success(`Link copiado`);
      },
    },
    {
      Icon: FaShare,
      toolTipName: "Compartir",
      imageRole: ["OWNER", "COOWNER", "READER"],
      onAvailable: () => !!image && !!image.available && !!image.published,
      onClick: () => {
        dispatch(showModal("share-user-image"));
      },
    },
    {
      Icon: BsFillTrash2Fill,
      imageRole: ["OWNER"],
      toolTipName: "Eliminar Image",
      onAvailable: () => !!image,
      onClick: () => {
        dispatch(showModal("confirm-delete-item-secuencial-modal"));
      },
    },
  ];

  useEffect(() => {
    if (!!params.id) {
      dispatch(getImage({ _id: params.id }));
    }
    if (!params.id && !!image) {
      dispatch({ type: SET_GET_IMAGE, response: null });
    }
  }, [params]);

  useEffect(() => {
    !cohorts &&
      fetchOn &&
      dispatch(
        getAllCohorts({ filterBy: { academy: current.id, active: true } })
      );
  }, [cohorts, fetchOn]);

  useEffect(() => {
    if (cohorts && fetchOn) {
      dispatch(
        getAllUnits({
          filterBy: { cohort: { $in: cohorts.map((cohort) => cohort._id) } },
        })
      );
    }
  }, [cohorts]);
  useEffect(() => {
    if (!cohorts && !units) {
      setFetchOn(true);
    }
  }, [cohorts, units]);

  useEffect(() => {
    if (!!image) {
      setImageDataChanged({
        name: image.name,
        description: image.description,
      });
      setImageApi(image.picture);
    } else {
      setImageDataChanged({
        name: "",
        description: "",
      });
      setImageApi(undefined);
    }
  }, [image]);

  useEffect(() => {
    if (newImageDataStates.success) {
      toast.success("Se creo el contenido exitosamente");
      if (!!newImage) {
        navigate(newImage._id);
      }
      setTimeout(() => {
        dispatch(resetNewImage());
      }, 1000);
    }
    if (newImageDataStates.error) {
      toast.error("No se pudo crear la imagen");
      setTimeout(() => {
        dispatch(resetNewImage());
      }, 1000);
    }
  }, [newImageDataStates]);

  useEffect(() => {
    if (updateImageStates.success) {
      dispatch(getImage({ _id: image._id }));
      toast.success(`👌🏼 Contenido guardado`);
      dispatch(resetGetImage());
      dispatch(resetUpdateImage());
    }
    if (updateImageStates.error) {
      dispatch(getImage({ _id: image._id }));
      toast.error(
        `${updateImageStates.error || "No se pudo actualizar contenido"}`
      );
      dispatch(resetGetImage());
      dispatch(resetUpdateImage());
    }
  }, [updateImageStates]);

  useEffect(() => {
    if (getImageStates.success) {
      dispatch(resetGetImage());
    }
    if (getImageStates.error) {
      dispatch(resetGetImage());
    }
  }, [getImageStates]);

  useEffect(() => {
    return () => {
      dispatch(resetGetAllCohortsData());
      dispatch(resetGetAllUnits());
    };
  }, []);

  if ((!!params.id && !image) || getImageStates.loading)
    return <Loader color="Primary"></Loader>;
  return (
    <>
      <Grid.Container>
        <Formik
          initialValues={initialValues({
            name: imageDataChanged.name,
            description: imageDataChanged.description,
          })}
          onSubmit={(values, actions) => {
            onSubmit(values, actions);
          }}
          validateOnChange={false}
          validateOnBlur={false}
          validationSchema={schema}
          validateOnMount={false}
          enableReinitialize
        >
          {({
            touched,
            errors,
            values,
            handleChange,
            handleBlur,
            handleSubmit,
            resetForm,
            setFieldValue,
            isSubmitting,
          }) => {
            return (
              <form
                className="theme-form"
                onSubmit={(event) => {
                  setFormSubmmited(true);
                  handleSubmit(event);
                }}
                id="image-player-create"
              >
                <FlexContainer gap="10px">
                  <div style={{ width: "calc(100% - 50px)" }}>
                    <FlexContainer direction="column" gap="10px">
                      {!currentImage && !imageApi ? (
                        <DropzoneField
                          name="videoImg"
                          onChange={(files) => {
                            onSelectImage(files);
                          }}
                          onBlur={handleBlur}
                          error={errors["videoImg"]}
                          touched={touched["videoImg"]}
                          placeholder={
                            "Selecciona el archivo que quieras subir"
                          }
                          options={{ size: "big", openOnClick: true }}
                          validation={{
                            maxFileSize: 1024,
                            maxFiles: 1,
                            accept: "image/*",
                          }}
                        />
                      ) : (
                        <ImageImagePreview
                          height={"500px"}
                          style={{
                            ...(!!currentImage && {
                              backgroundImage: `url(${currentImage?.preview})`,
                            }),
                            ...(!!imageApi && {
                              backgroundImage: `url(${imageApi})`,
                            }),
                            backgroundSize: "contain",
                            backgroundRepeat: "no-repeat",
                            backgroundPosition: "center center",
                          }}
                        >
                          {!!currentImage && (
                            <RiCloseCircleFill
                              onClick={() => {
                                setCurrentImage(undefined);
                              }}
                              size={25}
                              fill={"#E91E63"}
                              color={"#fff"}
                              style={{
                                position: "absolute",
                                top: "10px",
                                right: "10px",
                              }}
                            ></RiCloseCircleFill>
                          )}
                        </ImageImagePreview>
                      )}
                      <ImageUploaderDescriptionWrapper>
                        <FlexContainer
                          justify="space-between"
                          wrap="wrap"
                          gap="10px"
                        >
                          <FlexContainer direction="column" gap="12px">
                            <FlexContainer
                              direction="column"
                              gap="12px"
                              style={{ width: "360px" }}
                            >
                              <InputDescription
                                containerStyles={{
                                  width: "100%",
                                  maxWidth: "340px",
                                  borderColor: "#697482",
                                }}
                                name="name"
                                touched={touched["name"]}
                                error={errors["name"]}
                                value={values["name"]}
                                type="text"
                                placeholder="Nombre del Image"
                                onChange={(ev) => {
                                  setImageDataChanged((state) => {
                                    return {
                                      ...state,
                                      name: ev.target.value,
                                    };
                                  });
                                  handleChange(ev);
                                }}
                                onBlur={handleBlur}
                                options={{
                                  marginBottom: 10,
                                }}
                              />
                              <TextArea
                                containerStyles={{
                                  width: "100%",
                                  maxWidth: "340px",
                                }}
                                name="description"
                                error={errors["description"]}
                                touched={touched["description"]}
                                value={values["description"]}
                                onChange={(ev) => {
                                  setImageDataChanged((state) => {
                                    return {
                                      ...state,
                                      description: ev.target.value,
                                    };
                                  });
                                  handleChange(ev);
                                }}
                                placeholder="Escriba su descripcion"
                                onBlur={handleBlur}
                                options={{
                                  skin: "base",
                                  marginBottom: 10,
                                }}
                              />
                              <FlexContainer
                                gap="10px"
                                align="center"
                                wrap="wrap"
                              >
                                {!image && (
                                  <>
                                    <Submit
                                      isSubmmiting={imageUpdateStates.loading}
                                      form="image-player-create"
                                      color="Primary"
                                      options={{
                                        type: "filled",
                                        skin: "primary",
                                        size: "lg",
                                      }}
                                    >
                                      Publicar Rapido
                                    </Submit>

                                    <Button
                                      onClick={() => {
                                        dispatch(
                                          showModal("publish-image-modal")
                                        );
                                      }}
                                      type="button"
                                      options={{
                                        type: "filled",
                                        skin: "primary",
                                        size: "lg",
                                      }}
                                      style={{ marginLeft: "10px" }}
                                    >
                                      Publicar
                                    </Button>
                                  </>
                                )}
                              </FlexContainer>
                            </FlexContainer>
                          </FlexContainer>
                          <div></div>
                        </FlexContainer>
                      </ImageUploaderDescriptionWrapper>
                    </FlexContainer>
                  </div>
                  <SideBar image={image} menu={menu}></SideBar>
                </FlexContainer>
              </form>
            );
          }}
        </Formik>
      </Grid.Container>

      <PublishImageModal
        imageDataChanged={imageDataChanged}
        imageApi={imageApi}
        currentImage={currentImage}
        image={image}
      ></PublishImageModal>

      {!!image && <AddUsersModal image={image}></AddUsersModal>}
      {!!image && <ShareModal image={image}></ShareModal>}
      {!!image && (
        <PrivateModal
          image={{
            _id: image._id,
            published: image.published,
            name: imageDataChanged.name,
            description: imageDataChanged.description,
            __v: image.__v,
          }}
        ></PrivateModal>
      )}

      {!!image && (
        <ModalConfirmDelete
          bntConfig={{
            content: "Eliminar",
            style: {
              style: { width: "170px", height: "40px" },
              color: "Danger",
              options: {
                type: "filled",
                skin: "danger",
                size: "lg",
                marginBottom: "0px",
              },
            },
          }}
          sucessAction={() => navigate("/dashboard/contents/images")}
          states={deleteImageStates}
          description={`La imagen se eliminara para siempre del sistema.`}
          title={
            <span
              style={{
                color: "#697482",
                fontSize: "20px",
                fontWeight: "600",
              }}
            >
              {`¿Seguro que quiere eliminar a ${image.name}?`}
            </span>
          }
          elementActions={deleteImage({ _id: image._id })}
          resetAction={resetDeleteImage}
          resetState={() => {}}
        ></ModalConfirmDelete>
      )}
    </>
  );
};

const states = ({
  usersStore,
  currentStore,
  userStore,
  imageStore,
  cohortStore,
  unitStore,
}) => {
  const { states: imageGetStates } = imageStore.image;
  const { states: imageUpdateStates } = imageStore.update;
  const { states: imageDeleteStates } = imageStore.delete;
  const { data: users } = usersStore.all;
  const { data: images } = imageStore.all;
  const { data: current } = currentStore;
  const { data: user } = userStore;
  const { data: image } = imageStore.image;
  const { states: newImageDataStates, data: newImage } = imageStore.new;
  const { states: updateImageStates } = imageStore.update;
  const { states: getImageStates } = imageStore.image;
  const { states: deleteImageStates } = imageStore.delete;
  const { data: cohorts } = cohortStore.allCohorts;
  const { data: units } = unitStore.allUnits;
  return {
    cohorts,
    units,
    imageGetStates,
    imageUpdateStates,
    users,
    imageDeleteStates,
    images,
    current,
    newImageDataStates,
    user,
    image,
    newImage,
    updateImageStates,
    getImageStates,
    deleteImageStates,
  };
};

export default connect(states)(Component);
